import { useQuery } from 'react-query';
import apiFetch from '@scale/frontend-lib/api-fetch';

import { IProjectGroup, DailyPlanOverviewQueryParams } from '@scale/shared/dailyPlan/types/api';

const PROJECT_GROUP_BASE_URL = 'corp-api/project-groups';

const DAILY_PLANNING_PAGE_QUERY_KEY = 'daily-planning-page';

function useGetProjectGroup({
  projectGroupId,
}: Pick<DailyPlanOverviewQueryParams, 'projectGroupId'>) {
  return useQuery<IProjectGroup, Error>(
    [DAILY_PLANNING_PAGE_QUERY_KEY, 'sla', projectGroupId],
    () =>
      apiFetch(null, `${PROJECT_GROUP_BASE_URL}/${projectGroupId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    {
      enabled: !!projectGroupId,
    },
  );
}

export { useGetProjectGroup };
